import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.css'],
  standalone: false,
})
export class WidgetComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


}
